export const base = {
  FONT_SIZE_TINY: 8,
  FONT_SIZE_SMALL: 12,
  FONT_SIZE_MEDIUM: 14,
  FONT_SIZE_LARGE: 18,
  FONT_SIZE_EXTRA_LARGE: 24,
  FONT_SIZE_MASSIVE: 34,

  FONT_WEIGHT_LIGHT: "200",
  FONT_WEIGHT_MEDIUM: "500",
  FONT_WEIGHT_BOLD: "700",
};

export const darkTheme = {
  PRIMARY_BACKGROUND_COLOR: "#3d3d3d",
  PRIMARY_BACKGROUND_COLOR_FAINT: "#797979",
  PRIMARY_BACKGROUND_COLOR_STRONG: "#d3d3d3",

  SECONDARY_BACKGROUND_COLOR: "#ffffff",
  SECONDARY_BACKGROUND_COLOR_FAINT: "#dddddd",
  SECONDARY_BACKGROUND_COLOR_STRONG: "#7f7f7f",

  ERROR_BACKGROUND_COLOR: "#423f3f",
  ERROR_BACKGROUND_COLOR_FAINT: "#e0b4b4",
  ERROR_BACKGROUND_COLOR_STRONG: "#9f3a38",

  PRIMARY_TEXT_COLOR: "#ffffff",
  PRIMARY_TEXT_COLOR_FAINT: "#dddddd",
  PRIMARY_TEXT_COLOR_STRONG: "#7f7f7f",
  SECONDARY_TEXT_COLOR: "#3d3d3d",
  ERROR_TEXT_COLOR: "#9f3a38",

  PRIMARY_TEXT_BACKGROUND_COLOR: "#3d3d3d",
  SECONDARY_TEXT_BACKGROUND_COLOR: "#ffffff"
};
export const lightTheme = {
  PRIMARY_BACKGROUND_COLOR: "#ffffff",
  PRIMARY_BACKGROUND_COLOR_FAINT: "#dddddd",
  PRIMARY_BACKGROUND_COLOR_STRONG: "#7f7f7f",

  SECONDARY_BACKGROUND_COLOR: "#3d3d3d",
  SECONDARY_BACKGROUND_COLOR_FAINT: "#797979",
  SECONDARY_BACKGROUND_COLOR_STRONG: "#d3d3d3",

  ERROR_BACKGROUND_COLOR: "#fff6f6",
  ERROR_BACKGROUND_COLOR_FAINT: "#e0b4b4",
  ERROR_BACKGROUND_COLOR_STRONG: "#9f3a38",

  PRIMARY_TEXT_COLOR: "#3d3d3d",
  PRIMARY_TEXT_COLOR_FAINT: "#797979",
  PRIMARY_TEXT_COLOR_STRONG: "#d3d3d3",
  SECONDARY_TEXT_COLOR: "#ffffff",
  ERROR_TEXT_COLOR: "#9f3a38",

  PRIMARY_TEXT_BACKGROUND_COLOR: "#ffffff",
  SECONDARY_TEXT_BACKGROUND_COLOR: "#3d3d3d"
};

